import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    init() {

    }

    /**
     * Toggler
     *
     * @param item {node}
     */
    toggle(e) {
        let el = e.curTarget;
        let parent = this.parent('item', el);

        if(parent.classList.contains('is-open')) {
            this.close();
        } else {
            this.close();
            this.open(parent);
        }
    }

    /**
     * open
     *
     * @param parentNode item {node}
     */
    open(item) {
        let collapsible = this.$('content', item)[0];
        item.classList.add('is-open');

        gsap.to(collapsible, 0.3, {
            height: this.compute(this.$('inner', item)[0]).height,
            onComplete: () => {
                this.call('update', 'Scroll');
            }
        })
    }

    /**
     * Close
     *
     * @param
     */
    close() {
        this.$('item').forEach((item) => {
            item.classList.remove('is-open');

            let collapsible = this.$('content', item)[0];

            if(collapsible) {
                gsap.to(collapsible, 0.3, {
                    height: 0,
                    onComplete: () => {
                        this.call('update', 'Scroll');
                    }
                })
            }
        })
    }

    /**
     * compute
     *
     * @param
     */
    compute(item) {
        return item.getBoundingClientRect();
    }
}